import { stripSensitiveFields } from 'utils/strip-sensitive-fields';
import React from 'react'
import Head from 'next/head'
import { downloadAbout, downloadProfilePic, getStringUserIdFromHandleName } from '../../../../api/user/profile-api';
import { useRouter } from 'next/router'
import { downloadMyBuzz } from '../../../../api/post/buzz-api';
import { MyBuzz } from '../../../../components/profile/posts/MyBuzz';

// This gets called on every request
export async function getServerSideProps({params, res}) {
  // Fetch data from external API
  const handleName = params.handleName
  const stringsUserId = (await getStringUserIdFromHandleName(handleName)).toString()
  const about = stripSensitiveFields(await downloadAbout("", stringsUserId))
  const profilePicture = await downloadProfilePic(stringsUserId)
  console.log("stringsUserId", stringsUserId)
  const myPosts = await downloadMyBuzz("", stringsUserId, 6, 0)

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=86400, stale-while-revalidate=59'
  )

  return {
    props: {
      handleName,
      stringsUserId,
      myPosts,
      about,
      profilePicture
    },
  }
}

export default function Home(props) {
  const router = useRouter()
  const stringHandleName = props.handleName
  const stringsUserId = props.stringsUserId
  const category = router.query.category

  const about = props.about
  const myPosts = props.myPosts
  const profilePicture = props.profilePicture

  return (
    <>
      <Head>
        <title>{`Posted by ${about.userFirstName} ${about.userLastName} | ${about.category} | StringsSG`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content={`Buzz by ${about.userFirstName} ${about.userLastName}`}/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content={"https://www.stringssg.com/profile/" + stringHandleName + "/posts"} />
        <meta property="og:type"   content="website" />
        <meta property="og:title"   content={`Posted by ${about.userFirstName} ${about.userLastName} | ${about.category} | StringsSG`} />
        <meta property="og:description" content={`Buzz by ${about.userFirstName} ${about.userLastName}`} />
        <meta property="og:image"  content={profilePicture}/>
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={profilePicture}/>
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url"  content={"https://www.stringssg.com/profile/" + stringHandleName + "/posts"}/>
        <meta name="twitter:title" content={`Posted by ${about.userFirstName} ${about.userLastName} | ${category} | StringsSG`}/> 
        <meta name="twitter:description" content={`Buzz by ${about.userFirstName} ${about.userLastName}`}/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={"https://www.stringssg.com/profile/" + stringHandleName + "/posts"} />
      </Head>   
        <div className="max-w-4xl mx-auto overflow-hidden">   
            <MyBuzz myPosts={myPosts} stringsUserId={stringsUserId} stringHandleName={stringHandleName}/>
        </div>
    </>
  )
}
